import React, { useState, useEffect, useRef } from 'react'

// import Loader from '../../../loader';

import HomeFloatingContent01 from './HomeFloatingContent_01';
import HomeFloatingContent02 from './HomeFloatingContent_02';
import HomeFloatingContent03 from './HomeFloatingContent_03';
import HomeFloatingContent04 from './HomeFloatingContent_04';
import HomeFloatingContent05 from './HomeFloatingContent_05';
import HomeFloatingContent06 from './HomeFloatingContent_06';
import HomeFloatingContent07 from './HomeFloatingContent_07';
import HomeFloatingContent08 from './HomeFloatingContent_08';
import HomeFloatingContent09 from './HomeFloatingContent_09';
import HomeFloatingContent10 from './HomeFloatingContent_10';
import HomeFloatingContent11 from './HomeFloatingContent_11';

export default function Content(props) {

	const [, set_dados] = useState(null)
	const dados_config = useRef({})
	const dados_component = useRef({})
	const template = useRef({})
	const layout = useRef('')
	const content = useRef({})
	const pw = useRef({})
	const component_order = useRef(0)

    const [isloading, setLoading] = useState(true);

    useEffect(() => {

        if(props.dados_config !== undefined && props.dados_config !== null && props.dados_config !== '') {
            set_dados(dados_config.current = props.dados_config)
            set_dados(template.current = props.dados_config.info.template)
            set_dados(content.current = props.dados_config)
            set_dados(pw.current = props.pag_welcome)
            set_dados(layout.current = props.layout)
            set_dados(dados_component.current = props.dados_component)
            set_dados(component_order.current = props.component_order)

            //console.log('props.layout', props.layout)

            setLoading(false)
        }

    }, [props]);

    return (isloading ?
		null
    :
        layout.current === 'home-floating-content-01' ?
            <HomeFloatingContent01 pag_welcome={pw.current} dados_config={dados_config.current} dados_component={dados_component.current} component_order={component_order.current} />
        :
        layout.current === 'home-floating-content-02' ?
            <HomeFloatingContent02 pag_welcome={pw.current} dados_config={dados_config.current} dados_component={dados_component.current} component_order={component_order.current} />
        :
        layout.current === 'home-floating-content-03' ?
            <HomeFloatingContent03 pag_welcome={pw.current} dados_config={dados_config.current} dados_component={dados_component.current} component_order={component_order.current} />
        :
        layout.current === 'home-floating-content-04' ?
            <HomeFloatingContent04 pag_welcome={pw.current} dados_config={dados_config.current} dados_component={dados_component.current} component_order={component_order.current} />
        :
        layout.current === 'home-floating-content-05' ?
            <HomeFloatingContent05 pag_welcome={pw.current} dados_config={dados_config.current} dados_component={dados_component.current} component_order={component_order.current} />
        :
        layout.current === 'home-floating-content-06' ?
            <HomeFloatingContent06 pag_welcome={pw.current} dados_config={dados_config.current} dados_component={dados_component.current} component_order={component_order.current} />
        :
        layout.current === 'home-floating-content-07' ?
            <HomeFloatingContent07 pag_welcome={pw.current} dados_config={dados_config.current} dados_component={dados_component.current} component_order={component_order.current} />
        :
        layout.current === 'home-floating-content-08' ?
            <HomeFloatingContent08 pag_welcome={pw.current} dados_config={dados_config.current} dados_component={dados_component.current} component_order={component_order.current} />
        :
        layout.current === 'home-floating-content-09' ?
            <HomeFloatingContent09 pag_welcome={pw.current} dados_config={dados_config.current} dados_component={dados_component.current} component_order={component_order.current} />
        :
        layout.current === 'home-floating-content-10' ?
            <HomeFloatingContent10 pag_welcome={pw.current} dados_config={dados_config.current} dados_component={dados_component.current} component_order={component_order.current} />
        :
        layout.current === 'home-floating-content-11' ?
            <HomeFloatingContent11 pag_welcome={pw.current} dados_config={dados_config.current} dados_component={dados_component.current} component_order={component_order.current} />
        :
            <HomeFloatingContent01 pag_welcome={pw.current} dados_config={dados_config.current} dados_component={dados_component.current} component_order={component_order.current} />
    )
}
